import React, { useState } from 'react'
import PropTypes from 'prop-types';

import { useDatosGenerales } from '../hooks/useDatosGenerales';
import { useForm, useFormValidation } from '../../../../../hooks';

import { CheckboxInput, ColorInput, LightButton, PrimaryButton, TextAreaInput } from "../../../../../components";

import styles from './../DatosGenerales.module.css';

export const DatosGeneralesUpdate = ({ datosGenerales }) => {

    const { updateDatosGeneralesMutation: { mutate: updateDatosGenerales, isPending } } = useDatosGenerales();

    const [dataStatus, setDataStatus] = useState(false);

    const { nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, generoFemenino, generoMasculino, generoOtro, generoPrefieroNoDecirlo, email, telefono, celular, medioContacto, medioContactoInstagram, medioContactoFacebook, medioContactoTiktok, medioContactoPaginaWeb, medioContactoReferenciaOtroDoctor, medioContactoReferenciaFamiliar, medioContactoReferenciaAmistad, medioContactoCentroMedico, medioContactoOtro, medioContactoNoEspecificado, nacionalidad, estadoCivil, ocupacion, religion, origen, residencia, calle, numero, colonia, municipio, entidadFederativa, pais, codigoPostal, parentescoTutor, nombreTutor, emailTutor, celularTutor, heredofamiliares, personalesPatologicos, personalesNoPatologicos, ginobstetricos, perinatales, bienvenida, confirmacionCita, colorTema, onInputChange, onResetForm } = useForm({ nombre: datosGenerales.fichaIdentificacion.nombre, apellidoPaterno: datosGenerales.fichaIdentificacion.apellidoPaterno, apellidoMaterno: datosGenerales.fichaIdentificacion.apellidoMaterno, fechaNacimiento: datosGenerales.fichaIdentificacion.fechaNacimiento, genero: datosGenerales.fichaIdentificacion.genero, generoFemenino: datosGenerales.fichaIdentificacion.generoFemenino, generoMasculino: datosGenerales.fichaIdentificacion.generoMasculino, generoOtro: datosGenerales.fichaIdentificacion.generoOtro, generoPrefieroNoDecirlo: datosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo, email: datosGenerales.fichaIdentificacion.email, telefono: datosGenerales.fichaIdentificacion.telefono, celular: datosGenerales.fichaIdentificacion.celular, medioContacto: datosGenerales.fichaIdentificacion.medioContacto, medioContactoInstagram: datosGenerales.fichaIdentificacion.medioContactoInstagram, medioContactoFacebook: datosGenerales.fichaIdentificacion.medioContactoFacebook, medioContactoTiktok: datosGenerales.fichaIdentificacion.medioContactoTiktok, medioContactoPaginaWeb: datosGenerales.fichaIdentificacion.medioContactoPaginaWeb, medioContactoReferenciaOtroDoctor: datosGenerales.fichaIdentificacion.medioContactoReferenciaOtroDoctor, medioContactoReferenciaFamiliar: datosGenerales.fichaIdentificacion.medioContactoReferenciaFamiliar, medioContactoReferenciaAmistad: datosGenerales.fichaIdentificacion.medioContactoReferenciaAmistad, medioContactoCentroMedico: datosGenerales.fichaIdentificacion.medioContactoCentroMedico, medioContactoOtro: datosGenerales.fichaIdentificacion.medioContactoOtro, medioContactoNoEspecificado: datosGenerales.fichaIdentificacion.medioContactoNoEspecificado, nacionalidad: datosGenerales.fichaIdentificacion.nacionalidad, estadoCivil: datosGenerales.fichaIdentificacion.estadoCivil, ocupacion: datosGenerales.fichaIdentificacion.ocupacion, religion: datosGenerales.fichaIdentificacion.religion, origen: datosGenerales.fichaIdentificacion.origen, residencia: datosGenerales.fichaIdentificacion.residencia, calle: datosGenerales.domicilio.calle, numero: datosGenerales.domicilio.numero, colonia: datosGenerales.domicilio.colonia, municipio: datosGenerales.domicilio.municipio, entidadFederativa: datosGenerales.domicilio.entidadFederativa, pais: datosGenerales.domicilio.pais, codigoPostal: datosGenerales.domicilio.codigoPostal, parentescoTutor: datosGenerales.tutores.parentesco, nombreTutor: datosGenerales.tutores.nombre, emailTutor: datosGenerales.tutores.email, celularTutor: datosGenerales.tutores.celular, heredofamiliares: datosGenerales.antecedentes.heredofamiliares, personalesPatologicos: datosGenerales.antecedentes.personalesPatologicos, personalesNoPatologicos: datosGenerales.antecedentes.personalesNoPatologicos, ginobstetricos: datosGenerales.antecedentes.ginobstetricos, perinatales: datosGenerales.antecedentes.perinatales, bienvenida: datosGenerales.personalizacion.bienvenida, confirmacionCita: datosGenerales.personalizacion.confirmacionCita, colorTema: datosGenerales.personalizacion.colorTema });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'nombre', default: true}, {field: 'apellidoPaterno', default: true}, {field: 'apellidoMaterno', default: true}, {field: 'fechaNacimiento', default: true}, {field: 'genero', default: true}, {field: 'generoFemenino', default: true}, {field: 'generoMasculino', default: true}, {field: 'generoOtro', default: true}, {field: 'generoPrefieroNoDecirlo', default: true}, {field: 'email', default: true}, {field: 'telefono', default: true}, {field: 'celular', default: true}, {field: 'medioContacto', default: true}, {field: 'medioContactoInstagram', default: true}, {field: 'medioContactoFacebook', default: true}, {field: 'medioContactoTiktok', default: true}, {field: 'medioContactoPaginaWeb', default: true}, {field: 'medioContactoReferenciaOtroDoctor', default: true}, {field: 'medioContactoReferenciaFamiliar', default: true}, {field: 'medioContactoReferenciaAmistad', default: true}, {field: 'medioContactoCentroMedico', default: true}, {field: 'medioContactoOtro', default: true}, {field: 'medioContactoNoEspecificado', default: true}, {field: 'nacionalidad', default: true}, {field: 'estadoCivil', default: true}, {field: 'religion', default: true}, {field: 'origen', default: true}, {field: 'residencia', default: true}, {field: 'ocupacion', default: true}, {field: 'calle', default: true}, {field: 'numero', default: true}, {field: 'colonia', default: true}, {field: 'municipio', default: true}, {field: 'entidadFederativa', default: true}, {field: 'pais', default: true}, {field: 'codigoPostal', default: true}, {field: 'parentescoTutor', default: true}, {field: 'nombreTutor', default: true}, {field: 'emailTutor', default: true}, {field: 'celularTutor', default: true}, {field: 'heredofamiliares', default: true}, {field: 'personalesPatologicos', default: true}, {field: 'personalesNoPatologicos', default: true}, {field: 'ginobstetricos', default: true}, {field: 'perinatales', default: true}, {field: 'bienvenida', default: true}, {field: 'confirmacionCita', default: true}, {field: 'colorTema', default: true}]);

    const handleChange = (e) => {
        setDataStatus(true);
        onInputChange(e);
    }

    const handleCancelChange = () => {
        onResetForm();
        setDataStatus(false);
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateDatosGenerales({ data: { nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, generoFemenino, generoMasculino, generoOtro, generoPrefieroNoDecirlo, email, telefono, celular, medioContacto, medioContactoInstagram, medioContactoFacebook, medioContactoTiktok, medioContactoPaginaWeb, medioContactoReferenciaOtroDoctor, medioContactoReferenciaFamiliar, medioContactoReferenciaAmistad, medioContactoCentroMedico, medioContactoOtro, medioContactoNoEspecificado, nacionalidad, estadoCivil, religion, origen, residencia, ocupacion, calle, numero, colonia, municipio, entidadFederativa, pais, codigoPostal, parentescoTutor, nombreTutor, emailTutor, celularTutor, heredofamiliares, personalesPatologicos, personalesNoPatologicos, ginobstetricos, perinatales, bienvenida, confirmacionCita, colorTema } });
            setDataStatus(false);
        }else{
          startFormValidation();
        }
    
    }

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Ficha de identificación</div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Nombre(s)"
                                name="nombre"
                                onChange={ handleChange }
                                required={false}
                                checked={ (nombre === 'true' || nombre === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Apellido paterno"
                                name="apellidoPaterno"
                                onChange={ handleChange }
                                required={false}
                                checked={ (apellidoPaterno === 'true' || apellidoPaterno === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Apellido materno"
                                name="apellidoMaterno"
                                onChange={ handleChange }
                                required={false}
                                checked={ (apellidoMaterno === 'true' || apellidoMaterno === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Fecha de nacimiento"
                                name="fechaNacimiento"
                                onChange={ handleChange }
                                required={false}
                                checked={ (fechaNacimiento === 'true' || fechaNacimiento === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Género"
                                name="genero"
                                onChange={ handleChange }
                                required={false}
                                checked={ (genero === 'true' || genero === true) ? true : false }
                            />
                        </div>
                        <div className="col"></div>
                    </div>
                    <div className="row mb-3">
                        <div className="col"></div>
                        <div className="col"></div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    disabled={true}
                                    label="Femenino"
                                    name="generoFemenino"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (generoFemenino === 'true' || generoFemenino === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    disabled={true}
                                    label="Masculino"
                                    name="generoMasculino"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (generoMasculino === 'true' || generoMasculino === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Otro"
                                    name="generoOtro"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (generoOtro === 'true' || generoOtro === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Prefiero no decirlo"
                                    name="generoPrefieroNoDecirlo"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (generoPrefieroNoDecirlo === 'true' || generoPrefieroNoDecirlo === true) ? true : false }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Correo electrónico"
                                name="email"
                                onChange={ handleChange }
                                required={false}
                                checked={ (email === 'true' || email === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Teléfono fijo"
                                name="telefono"
                                onChange={ handleChange }
                                required={false}
                                checked={ (telefono === 'true' || telefono === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                disabled={true}
                                label="Teléfono móvil"
                                name="celular"
                                onChange={ handleChange }
                                required={false}
                                checked={ (celular === 'true' || celular === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Medio de contacto"
                                name="medioContacto"
                                onChange={ handleChange }
                                required={false}
                                checked={ (medioContacto === 'true' || medioContacto === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Instagram"
                                    name="medioContactoInstagram"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoInstagram === 'true' || medioContactoInstagram === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Facebook"
                                    name="medioContactoFacebook"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoFacebook === 'true' || medioContactoFacebook === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="TikTok"
                                    name="medioContactoTiktok"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoTiktok === 'true' || medioContactoTiktok === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Página Web"
                                    name="medioContactoPaginaWeb"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoPaginaWeb === 'true' || medioContactoPaginaWeb === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Referencia de otro doctor"
                                    name="medioContactoReferenciaOtroDoctor"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoReferenciaOtroDoctor === 'true' || medioContactoReferenciaOtroDoctor === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Referencia de familiar"
                                    name="medioContactoReferenciaFamiliar"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoReferenciaFamiliar === 'true' || medioContactoReferenciaFamiliar === true) ? true : false }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Referencia de amistad"
                                    name="medioContactoReferenciaAmistad"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoReferenciaAmistad === 'true' || medioContactoReferenciaAmistad === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Referencia de centro médico"
                                    name="medioContactoCentroMedico"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoCentroMedico === 'true' || medioContactoCentroMedico === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Otro"
                                    name="medioContactoOtro"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoOtro === 'true' || medioContactoOtro === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    disabled={true}
                                    label="No especificado"
                                    name="medioContactoNoEspecificado"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (medioContactoNoEspecificado === 'true' || medioContactoNoEspecificado === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col"></div>
                        <div className="col"></div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                label="Nacionalidad"
                                name="nacionalidad"
                                onChange={ handleChange }
                                required={false}
                                checked={ (nacionalidad === 'true' || nacionalidad === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Estado civil"
                                name="estadoCivil"
                                onChange={ handleChange }
                                required={false}
                                checked={ (estadoCivil === 'true' || estadoCivil === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Ocupación"
                                name="ocupacion"
                                onChange={ handleChange }
                                required={false}
                                checked={ (ocupacion === 'true' || ocupacion === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <CheckboxInput
                                label="Religión"
                                name="religion"
                                onChange={ handleChange }
                                required={false}
                                checked={ (religion === 'true' || religion === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Origen"
                                name="origen"
                                onChange={ handleChange }
                                required={false}
                                checked={ (origen === 'true' || origen === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Residencia"
                                name="residencia"
                                onChange={ handleChange }
                                required={false}
                                checked={ (residencia === 'true' || residencia === true) ? true : false }
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Domicilio</div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                label="Calle"
                                name="calle"
                                onChange={ handleChange }
                                required={false}
                                checked={ (calle === 'true' || calle === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Número"
                                name="numero"
                                onChange={ handleChange }
                                required={false}
                                checked={ (numero === 'true' || numero === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Colonia"
                                name="colonia"
                                onChange={ handleChange }
                                required={false}
                                checked={ (colonia === 'true' || colonia === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                label="Municipio"
                                name="municipio"
                                onChange={ handleChange }
                                required={false}
                                checked={ (municipio === 'true' || municipio === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Entidad Federativa"
                                name="entidadFederativa"
                                onChange={ handleChange }
                                required={false}
                                checked={ (entidadFederativa === 'true' || entidadFederativa === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="País"
                                name="pais"
                                onChange={ handleChange }
                                required={false}
                                checked={ (pais === 'true' || pais === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <CheckboxInput
                                label="Código postal"
                                name="codigoPostal"
                                onChange={ handleChange }
                                required={false}
                                checked={ (codigoPostal === 'true' || codigoPostal === true) ? true : false }
                            />
                        </div>
                        <div className="col"></div>
                        <div className="col"></div>
                    </div>
                </div>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Tutores</div>
                    <div className="row">
                        <div className="col">
                            <CheckboxInput
                                label="Parentesco"
                                name="parentescoTutor"
                                onChange={ handleChange }
                                required={false}
                                checked={ (parentescoTutor === 'true' || parentescoTutor === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Nombre(s)"
                                name="nombreTutor"
                                onChange={ handleChange }
                                required={false}
                                checked={ (nombreTutor === 'true' || nombreTutor === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Email"
                                name="emailTutor"
                                onChange={ handleChange }
                                required={false}
                                checked={ (emailTutor === 'true' || emailTutor === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Teléfono Móvil"
                                name="celularTutor"
                                onChange={ handleChange }
                                required={false}
                                checked={ (celularTutor === 'true' || celularTutor === true) ? true : false }
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Antecedentes</div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                label="Heredofamiliares"
                                name="heredofamiliares"
                                onChange={ handleChange }
                                required={false}
                                checked={ (heredofamiliares === 'true' || heredofamiliares === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Personales patológicos"
                                name="personalesPatologicos"
                                onChange={ handleChange }
                                required={false}
                                checked={ (personalesPatologicos === 'true' || personalesPatologicos === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Personales no patológicos"
                                name="personalesNoPatologicos"
                                onChange={ handleChange }
                                required={false}
                                checked={ (personalesNoPatologicos === 'true' || personalesNoPatologicos === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <CheckboxInput
                                label="Ginobstétricos"
                                name="ginobstetricos"
                                onChange={ handleChange }
                                required={false}
                                checked={ (ginobstetricos === 'true' || ginobstetricos === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Perinatales"
                                name="perinatales"
                                onChange={ handleChange }
                                required={false}
                                checked={ (perinatales === 'true' || perinatales === true) ? true : false }
                            />
                        </div>
                        <div className="col"></div>
                    </div>
                </div>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Personalización</div>
                    <div className="row">
                        <div className="col">
                            <TextAreaInput
                                formFieldStatus={ formFields['bienvenida'].status }
                                label="Mensaje de bienvenida"
                                name="bienvenida"
                                onChange={ handleChange }
                                required={ false }
                                requiredIndicator={ false }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ bienvenida }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <TextAreaInput
                                formFieldStatus={ formFields['confirmacionCita'].status }
                                label="Mensaje de confirmación de cita"
                                name="confirmacionCita"
                                onChange={ handleChange }
                                required={ false }
                                requiredIndicator={ false }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ confirmacionCita }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-1">
                            <ColorInput
                                formFieldStatus={ formFields['colorTema'].status }
                                label="Color de tema"
                                name="colorTema"
                                onChange={ handleChange }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ colorTema }
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12 col-md">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="X"
                                marginTop={false}
                                marginRight={true}
                                onClick={handleCancelChange}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="Check"
                                marginTop={false}
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

DatosGeneralesUpdate.propTypes = {
    datosGenerales: PropTypes.object.isRequired,
}